export const formatPercentageToNumber = (value: any, removePercentage?: boolean) => {
  if (removePercentage) return Number(String(value).replace(",", ".").replace("%", ""))
  return String(value).replace(".", ",").concat("%")
}